export default "__VITE_ASSET__bTj8WH8f__"